<template>
  <div class="home">
    <header class="bg-white header header-transparent position-sticky top-0">
      <div class="container-fluid header-wrapper">
        <!-- Brand-->
        <div class="inner-header">
          <a class="inner-brand" href="/">
            <img src="/img/home/logo.png" alt="" />
          </a>
        </div>
      </div>
    </header>
    <section>
      <!-- Navigation-->
      <div class="extra-nav">
        <p class="text-description">
          This is a placeholder for the marketing site used in production.
        </p>
        <ul>
          <li>
            <button
              @click="handleSignInClick"
              class="login menu-item-span btn btn-orange btn-rounded btn-orange-outline mr-3"
            >
              Sign In
            </button>
          </li>
          <li>
            <button
              @click="handleRegisterClick"
              class="menu-item-span btn btn-orange btn-rounded"
            >
              Sign Up
            </button>
          </li>
          <li class="nav-toggle">
            <a href="#" data-toggle="collapse" data-target=".inner-navigation"
              ><span class="menu-item-span"><i class="ti-menu"></i></span
            ></a>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home-page",
  data() {
    return {
      learnMore: null,
    }
  },
  methods: {
    handleRegisterClick(event) {
      const profileType =
        event.target.getAttribute("data-profileType") ?? "candidate"
      const path = `signup`
      this.$router.push({
        path,
        query: { profileType },
      })
    },
    handleSignInClick() {
      const path = `login`
      this.$router.push({
        path,
      })
    },
  },
}
</script>

<style scoped>
.collapse-image {
  cursor: pointer;
}
.center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.yellow-break {
  background: #fcbf49;
  color: white;
}
.get-started {
  border-radius: 100px !important;
  width: 260px !important;
}
.learn-more {
  position: relative;
  top: 115px;
  cursor: pointer;
}
.font-112-800 {
  color: inherit;
  font-weight: 800;
  font-size: 125px;
  line-height: 152px;
}
.font-78-800 {
  color: inherit;
  font-weight: 800;
  font-size: 55px;
  line-height: 59px;
}
.font-48-800 {
  color: inherit;
  font-weight: 800;
  font-size: 40px;
  line-height: 59px;
}
.font-35-500 {
  color: inherit;
  font-weight: 500;
  font-size: 24px;
  line-height: 46px;
}
.font-38-800 {
  color: inherit;
  font-weight: 800;
  font-size: 32px;
  line-height: 46px;
}
.font-24-700 {
  color: inherit;
  font-weight: 700;
  font-size: 1.2rem;
}

.font-20-800 {
  color: inherit;
  font-size: 1rem;
  line-height: 24px;
}
.font-20-900 {
  color: inherit;
  font-weight: 900;
  font-size: 1rem;
  line-height: 25px;
}
.font-20-500 {
  color: inherit;
  font-weight: 500;
  font-size: 0.9rem;
}

.font-18-500 {
  color: inherit;
  font-weight: 500;
  font-size: 0.8rem;
}

.font-14-500 {
  color: inherit;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.125rem;
}

a:hover {
  text-decoration: none;
}

.white-line {
  border-color: rgba(255, 255, 255, 0.2);
}

.dark-bg {
  background-color: #003049;
}
.orange-bg-900 {
  background-color: #f77f00;
}
.orange-bg-500 {
  background-color: rgba(247, 127, 0, 0.15);
}
.orange-bg-100 {
  background-color: rgba(247, 127, 0, 0.1);
}

.alpha-gray {
  color: rgba(255, 255, 255);
}

/* button */
.btn {
  -webkit-appearance: initial;
  overflow: hidden;
  position: -webkit-sticky;
  position: sticky;
  z-index: 2;
  display: inline-block;
  font-size: 12px;
  border: 2px solid transparent;
  letter-spacing: 0.3px;
  line-height: inherit;
  border-radius: 0;
  width: auto;
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease !important;
  transition: all 0.5s ease !important;
}

/* button size */
.btn.btn-small {
  font-size: 12px;
  padding: 4px 1.8em;
}
.btn.btn-medium {
  font-weight: 800;
  font-size: 1.375rem;
  padding: 4px 35px;
  line-height: 1.8em;
}
.btn.btn-large {
  font-weight: 900;
  font-size: 1rem;
  padding: 1rem 25px;
  line-height: 1rem;
  border-radius: 20px;
}
.btn.btn-rounded {
  border-radius: 50px;
}

/* organge button */
.btn.btn-orange {
  background: #f77f00;
  border-color: #f77f00;
  color: #ffffff;
}
.btn.btn-orange:hover {
  background: #000 !important;
  border-color: #000;
  color: #ffffff !important;
}

.btn.btn-orange-outline {
  background: #ffffff;
  border: 3px solid #f77f00;
  color: #f77f00;
}
.btn.btn-orange-outline:hover {
  background: #000 !important;
  border-color: #000;
  color: #ffffff !important;
}

/* Background color */
.bg-white {
  background: #ffffff;
}
.header {
  position: sticky;
  height: 97px;
  padding: 0 20px;
  width: 100%;
  transition: height 0.3s ease-out, background 0.3s ease-out,
    box-shadow 0.3s ease-out;
  transform: translate3d(0, 0, 0);
  z-index: 1040;

  .header-wrapper {
    display: flex;
    flex-direction: column;
    padding-top: 25px;
  }
}

.header.header-small {
  height: 60px;
  box-shadow: 0 0 60px 0 rgba(0, 0, 0, 0.07);
}

.header .container-fluid {
  position: relative;
  height: 100%;
}

.inner-header::before {
  display: inline-block;
  vertical-align: middle;
  height: 100%;
  margin-right: -1px;
  content: "";
}

.inner-header {
  position: relative;
  height: 100%;
  float: left;
  z-index: 1;
}

.inner-brand {
  display: inline-block;
  vertical-align: middle;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
  font-size: 1.25rem;
}

.extra-nav {
  position: relative;
  height: 100%;

  .text-description {
    padding-left: 1rem;
    margin-bottom: 40px;
    margin-top: 20px;
    font-weight: 400;
  }
}

.inner-navigation {
  position: absolute;
  height: 100%;
  float: left;
  right: 15px;
  left: 15px;
  text-align: center;
}

.inner-nav,
.extra-nav {
  vertical-align: middle;
  display: inline-block;
  height: 100%;
}

.inner-nav > ul {
  height: 100%;
  padding: 0;
  margin: 0;
}

.inner-nav > ul > li {
  position: relative;
  display: block;
  height: 100%;
  float: left;
  padding: 0 0.425rem;
  margin: 0;
}

.inner-nav > ul > li > a {
  position: relative;
  display: block;
  height: 100%;
  width: 100%;
  padding: 0 7px;
  letter-spacing: 0.05625rem;
  font-weight: 600;
  font-size: 0.9rem;
}

.inner-nav > ul > li > a > .menu-item-span {
  transform: translateY(-50%);
  position: relative;
  display: block;
  top: 50%;
}

.extra-nav {
  padding-left: 1.5rem;
}

.extra-nav > ul {
  height: 100%;
}

.extra-nav > ul > li {
  position: relative;
  display: block;
  height: 100%;
  float: left;
  margin: 0;
  transition: padding 0.3s ease-out;
}

.extra-nav > ul > li > button.login {
  color: #f77f00 !important;
}

.extra-nav > ul > li:only-child {
  padding-left: 5px;
}

.extra-nav > ul > li:last-child {
  padding-right: 0 !important;
}

.extra-nav > ul > li:last-child > a {
  padding-right: 0 !important;
}

.extra-nav > ul > li > button {
  position: relative;
  display: block;
  padding: 0 11px;
  letter-spacing: 0.05625rem;
}

.extra-nav > ul > li > .menu-item-span {
  transform: translateY(-50%);
  position: relative;
  display: block;
  top: 50%;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 6px 38px;
}

.top-bar-cart > span > span {
  position: absolute;
  background: #505cfd;
  border-radius: 100%;
  height: 15px;
  width: 15px;
  left: -4px;
  top: 1px;
  text-align: center;
  letter-spacing: 0;
  line-height: 16px !important;
  font-size: 0.5rem;
  color: #001a26;
}

.nav-toggle {
  display: block;
}

.header.header-transparent .inner-brand {
  color: #fff;
}

.header.header-transparent .inner-brand .brand-dark {
  display: none;
}

.header.header-transparent .inner-brand .brand-light {
  display: inline-block;
}

/* .header.header-transparent .extra-nav > ul > li > a,
.header.header-transparent .inner-nav > ul > li > a {
  color: ;
}

.header.header-transparent .extra-nav > ul > li > a:hover,
.header.header-transparent .extra-nav > ul > li > a.active,
.header.header-transparent .inner-nav > ul > li > a:hover,
.header.header-transparent .inner-nav > ul > li > a.active {
  color: #001a26;
} */

.header.header-transparent .extra-nav > ul > li:first-child {
  border-color: rgba(255, 255, 255, 0.1);
}

.header.header-transparent .inner-nav > ul > li > a:hover::after {
  background: #fff;
  margin-left: 0;
  width: 100%;
  left: 0;
}

.header.header-transparent .inner-nav > ul > li > a::after {
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  display: block;
  height: 1px;
  width: 20px;
  bottom: -1px;
  left: 50%;
  margin-left: -10px;
  content: "";
  transition: all 0.3s ease-out;
}

.header,
.header.header-small {
  background: #fff;
  border-bottom: 1px solid rgba(240, 240, 240, 0.8);
}

.header .inner-brand,
.header.header-small .inner-brand {
  color: #222;
}

.header .inner-brand .brand-dark,
.header.header-small .inner-brand .brand-dark {
  display: inline-block;
}

.header .inner-brand .brand-light,
.header.header-small .inner-brand .brand-light {
  display: none;
}

/* .header .extra-nav > ul > li > a,
.header .inner-nav > ul > li > a,
.header.header-small .extra-nav > ul > li > a,
.header.header-small .inner-nav > ul > li > a {
  color: rgba(0, 26, 38, 0.5);
} */

/* .header .extra-nav > ul > li > a:hover,
.header .extra-nav > ul > li > a.active, */
.header .inner-nav > ul > li > a:hover,
.header .inner-nav > ul > li > a.active,
/* .header.header-small .extra-nav > ul > li > a:hover,
.header.header-small .extra-nav > ul > li > a.active, */
.header.header-small .inner-nav > ul > li > a:hover,
.header.header-small .inner-nav > ul > li > a.active {
  color: #001a26;
}

.header .extra-nav > ul > li:first-child,
.header.header-small .extra-nav > ul > li:first-child {
  border-color: rgba(240, 240, 240, 0.8);
}

.header .inner-nav > ul > li > a::after,
.header.header-small .inner-nav > ul > li > a::after {
  display: none;
}
</style>
